<div class="nav-container">
  <nav class="nav">
    <tux-nav-platform-switcher
      [appName]="appName"
      #navPlatformMenuTrigger
      [matMenuTriggerFor]="navPlatformMenu"
      (click)="closeAllMenus({ except: 'platform-switcher' })"
    ></tux-nav-platform-switcher>
    <mat-menu
      #navPlatformMenu="matMenu"
      class="nav__platform-menu"
      backdropClass="custom-backdrop"
    >
      <tux-nav-platform-switcher-menu
        [homeLink]="homeLink"
        [platformData]="navPlatformData"
        [domain]="domain"
        (navClose)="closeAllMenus({})"
      ></tux-nav-platform-switcher-menu>
    </mat-menu>

    <div class="nav-sections">
      <div
        *ngFor="let navSection of navData; let last = last"
        class="nav-section"
      >
        <div *ngFor="let navItem of navSection" class="nav-section__nav-item">
          <p-badge *ngIf="navItem.badge" [value]="navItem.badge" />
          <tux-nav-item
            [navItem]="navItem"
            [active]="activeNavMenu === navItem"
            (click)="handleNavItemClick(navItem)"
          >
          </tux-nav-item>
        </div>
        <hr *ngIf="!last" class="nav-section__break" />
      </div>
      <div
        style="display: none"
        #navMenuTrigger
        [matMenuTriggerFor]="navMenu"
        (menuOpened)="closeAllMenus({ except: 'subnav' })"
      ></div>
      <mat-menu
        #navMenu="matMenu"
        class="nav__menu"
        backdropClass="custom-backdrop"
        (closed)="activeNavMenu = undefined"
      >
        <tux-nav-menu
          *ngIf="activeNavMenu"
          [menu]="activeNavMenu"
          (navMenuClosed)="activeNavMenu = undefined"
        ></tux-nav-menu>
      </mat-menu>
    </div>

    <span class="nav__spacer"></span>

    <tux-nav-profile
      #navProfileMenuTrigger
      [initial]="user.fullname[0]"
      [matMenuTriggerFor]="navProfileMenu"
      (menuOpened)="closeAllMenus({ except: 'profile' })"
    ></tux-nav-profile>
    <mat-menu
      #navProfileMenu
      class="nav__profile-menu"
      hasBackdrop="false"
      overlayPanelClass="test"
    >
      <tux-nav-profile-menu
        [user]="user"
        [impersonatingUser]="impersonatingUser"
        [profileData]="navProfileData"
      ></tux-nav-profile-menu>
    </mat-menu>
  </nav>
</div>
